import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useMemo } from 'react'
import { usePortalQueries } from 'src/Libs/api'
import { fetchStorageById } from 'src/Libs/installation-details/api/installation-details.api'
import { StorageModel } from 'src/Libs/storage/models'

export type ClientSoftwareVersion = {
  storageId: string
  softwareVersion: string | undefined
}

type ReturnType = {
  softwareVersions: ClientSoftwareVersion[]
  isLoading: boolean
}

export const getSoftwareVersionQueryKey = (storageId: string): [string, string] => ['storage-software-version', storageId]

/**
 * Fetches the software version of every farm participant (master + clients).
 */
export const useSoftwareVersionQueries = (storageIds: string[]): ReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const queries = usePortalQueries<StorageModel>(
    storageIds.map(storageId => ({
      queryKey: getSoftwareVersionQueryKey(storageId),
      queryFn: () => fetchStorageById(storageId, authFetch),
    }))
  )

  const isLoading = queries.some(query => query.isLoading)

  const softwareVersions = useMemo(
    () => storageIds.map((storageId, index) => ({ storageId, softwareVersion: queries[index]?.data?.softwareRelease })),
    [storageIds, queries]
  )

  return { softwareVersions, isLoading }
}
